/**
 * external libs
 */
import {useCallback, useEffect, useState} from "react";

export default function useKeyPressedHook() {
    const [pressedKey, setPressedKey] = useState([]);

    useEffect(() => {
        const onKeyDown = (e) => {
            if(!pressedKey.includes(e.which)){
                setPressedKey([...pressedKey, e.which]);
            }
        }

        const onKeyUp = (e) => {
            if(pressedKey.includes(e.which)){
                setPressedKey(pressedKey.filter( code => code !== e.which));
            }
        }

        document.addEventListener("keydown", onKeyDown)
        document.addEventListener("keyup", onKeyUp)

        return () => {
            document.removeEventListener("keydown", onKeyDown)
            document.removeEventListener("keyup", onKeyUp)
        }
    }, [pressedKey])
    return {pressedKey};
}
